"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _CreateMeter = _interopRequireDefault(require("../model/CreateMeter"));
var _SetChannels = _interopRequireDefault(require("../model/SetChannels"));
var _SetImportTime = _interopRequireDefault(require("../model/SetImportTime"));
var _UpdateMeter = _interopRequireDefault(require("../model/UpdateMeter"));
var _UpdateWattwatchersDevice = _interopRequireDefault(require("../model/UpdateWattwatchersDevice"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Meters service.
* @module api/MetersApi
* @version 0.1.0
*/
var MetersApi = /*#__PURE__*/function () {
  /**
  * Constructs a new MetersApi. 
  * @alias module:api/MetersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function MetersApi(apiClient) {
    _classCallCheck(this, MetersApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * @param {Number} id 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(MetersApi, [{
    key: "callDeleteWithHttpInfo",
    value: function callDeleteWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling callDelete");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "callDelete",
    value: function callDelete(id) {
      return this.callDeleteWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateMeter} opts.createMeter Payload for creating a new meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "createWithHttpInfo",
    value: function createWithHttpInfo(opts) {
      opts = opts || {};
      var postBody = opts['createMeter'];
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Object} opts Optional parameters
     * @param {module:model/CreateMeter} opts.createMeter Payload for creating a new meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "create",
    value: function create(opts) {
      return this.createWithHttpInfo(opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.attachChannels Attach channels to the meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWithHttpInfo",
    value: function getWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling get");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'attachChannels': opts['attachChannels']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {Boolean} opts.attachChannels Attach channels to the meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "get",
    value: function get(id, opts) {
      return this.getWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
     * @param {String} opts.timeContext Search on universal or local time; universal or local.
     * @param {Array.<String>} opts.fields List of properties to return; energyPositive, energyPositiveCo2, energyReactivePositive, energyNegative, energyNegativeCo2, energyReactiveNegative, powerFactorPositive, powerFactorNegative, voltageRmsMin, voltageRmsMax, currentRmsMin or currentRmsMax.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getChannelsDataFeedWithHttpInfo",
    value: function getChannelsDataFeedWithHttpInfo(id, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getChannelsDataFeed");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getChannelsDataFeed");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'timeContext': opts['timeContext'],
        'fields': this.apiClient.buildCollectionParam(opts['fields'], 'multi')
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}/channels/data-feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone; 2018-12-03 or 2018-12-03 13:00:00 or 2018-12-03T13:00:00.
     * @param {String} opts.timeContext Search on universal or local time; universal or local.
     * @param {Array.<String>} opts.fields List of properties to return; energyPositive, energyPositiveCo2, energyReactivePositive, energyNegative, energyNegativeCo2, energyReactiveNegative, powerFactorPositive, powerFactorNegative, voltageRmsMin, voltageRmsMax, currentRmsMin or currentRmsMax.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getChannelsDataFeed",
    value: function getChannelsDataFeed(id, start, opts) {
      return this.getChannelsDataFeedWithHttpInfo(id, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getLatestShortEnergyWithHttpInfo",
    value: function getLatestShortEnergyWithHttpInfo(id) {
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getLatestShortEnergy");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}/energy/short/latest', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getLatestShortEnergy",
    value: function getLatestShortEnergy(id) {
      return this.getLatestShortEnergyWithHttpInfo(id).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getMeterTypesWithHttpInfo",
    value: function getMeterTypesWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/types', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getMeterTypes",
    value: function getMeterTypes() {
      return this.getMeterTypesWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} utilityId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getMeterTypes_0WithHttpInfo",
    value: function getMeterTypes_0WithHttpInfo(utilityId) {
      var postBody = null;
      // verify the required parameter 'utilityId' is set
      if (utilityId === undefined || utilityId === null) {
        throw new Error("Missing the required parameter 'utilityId' when calling getMeterTypes_0");
      }
      var pathParams = {
        'utilityId': utilityId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/utilities/{utilityId}/types', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} utilityId 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getMeterTypes_0",
    value: function getMeterTypes_0(utilityId) {
      return this.getMeterTypes_0WithHttpInfo(utilityId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getShortEnergyWithHttpInfo",
    value: function getShortEnergyWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling getShortEnergy");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {
        'start': opts['start'],
        'end': opts['end']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}/energy/short', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {String} opts.start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getShortEnergy",
    value: function getShortEnergy(id, opts) {
      return this.getShortEnergyWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} deviceId ID of the Wattwatchers device.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWattwatchersDeviceWithHttpInfo",
    value: function getWattwatchersDeviceWithHttpInfo(deviceId) {
      var postBody = null;
      // verify the required parameter 'deviceId' is set
      if (deviceId === undefined || deviceId === null) {
        throw new Error("Missing the required parameter 'deviceId' when calling getWattwatchersDevice");
      }
      var pathParams = {
        'deviceId': deviceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/wattwatchers/device/{deviceId}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} deviceId ID of the Wattwatchers device.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getWattwatchersDevice",
    value: function getWattwatchersDevice(deviceId) {
      return this.getWattwatchersDeviceWithHttpInfo(deviceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "listUtilitiesWithHttpInfo",
    value: function listUtilitiesWithHttpInfo() {
      var postBody = null;
      var pathParams = {};
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/utilities', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "listUtilities",
    value: function listUtilities() {
      return this.listUtilitiesWithHttpInfo().then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/SetChannels} opts.setChannels Payload for setting channels for a meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "setChannelsWithHttpInfo",
    value: function setChannelsWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['setChannels'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setChannels");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}/channels', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/SetChannels} opts.setChannels Payload for setting channels for a meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "setChannels",
    value: function setChannels(id, opts) {
      return this.setChannelsWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/SetImportTime} opts.setImportTime Payload for setting the import time for a meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "setImportTimeWithHttpInfo",
    value: function setImportTimeWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['setImportTime'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling setImportTime");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}/import/time', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/SetImportTime} opts.setImportTime Payload for setting the import time for a meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "setImportTime",
    value: function setImportTime(id, opts) {
      return this.setImportTimeWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateMeter} opts.updateMeter Payload for updating a new meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateWithHttpInfo",
    value: function updateWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateMeter'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling update");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}', 'PUT', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateMeter} opts.updateMeter Payload for updating a new meter.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "update",
    value: function update(id, opts) {
      return this.updateWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateWattwatchersDevice} opts.updateWattwatchersDevice Payload for updating a Wattwatchers device.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "updateWattwatchersDeviceWithHttpInfo",
    value: function updateWattwatchersDeviceWithHttpInfo(id, opts) {
      opts = opts || {};
      var postBody = opts['updateWattwatchersDevice'];
      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
        throw new Error("Missing the required parameter 'id' when calling updateWattwatchersDevice");
      }
      var pathParams = {
        'id': id
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiAuthorizer', 'ApiKey'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/meters/{id}/wattwatchers/device', 'PATCH', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {Number} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/UpdateWattwatchersDevice} opts.updateWattwatchersDevice Payload for updating a Wattwatchers device.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "updateWattwatchersDevice",
    value: function updateWattwatchersDevice(id, opts) {
      return this.updateWattwatchersDeviceWithHttpInfo(id, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return MetersApi;
}();
exports["default"] = MetersApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/api/MetersApi.js
// module id = p0eh
// module chunks = 3